import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { useAuthLifecycleLogging } from '../../utils/authLifecycleLogger';
import usePageView from '../../hooks/usePageView';
import { ANALYTICS_EVENTS } from '../../constants/analyticsEvents';

const ClerkLogin = () => {
  usePageView(ANALYTICS_EVENTS.AUTH_LOGIN_VIEWED);
  // Diagnostic: same lifecycle telemetry as ClerkRegister. Sign-in normally
  // doesn't email a verification code, but multi-factor / new-device flows
  // do, so we instrument both pages symmetrically.
  useAuthLifecycleLogging('ClerkLogin');

  return (
    <div className="min-h-screen flex items-center justify-center bg-[linear-gradient(135deg,var(--bg-main)_0%,var(--bg-card)_50%,var(--bg-main)_100%)]">
      <SignIn
        routing="path"
        path="/clerk-login"
        signUpUrl="/clerk-register"
        fallbackRedirectUrl="/dashboard"
      />
    </div>
  );
};

export default ClerkLogin;
